<template>
  <div class="home">
    This is signup form
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "signup",
  data() {
    return {
      msg: this.$route.params.ref || null
    };
  }
};
</script>
